import { render, staticRenderFns } from "./tenant-dialog.vue?vue&type=template&id=07fdb0ca"
import script from "./tenant-dialog.ts?vue&type=script&lang=js&external"
export * from "./tenant-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports